module.exports = __webpack_public_path__ + "static/media/icon-delete.a15fc798.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-delete.svg
// module id = 912
// module chunks = 0